import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import classNames from 'classnames';
import { Box, Typography } from 'seagull';
import { Checkmark, CloseCross } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import ExternalLinkButton from '~/components/ExternalLinkButton';
import { useStoreStatic } from '~/contexts';
import { selectors } from '~/store/state-selectors';
import pluralize from '~/utils/pluralize';
import styles from './BulkBillingResultsDetails.module.scss';
export const GetBulkBillingResultsDetailsTID = (parentTestId)=>getTestIds(parentTestId);
export const BulkBillingResultsDetails = (param)=>{
    let { success, failure, bulkUploadId, testId } = param;
    const { getState } = useStoreStatic();
    const mgmtHost = selectors.mgmtHost(getState());
    const { BulkBillingResultsDetailsTestIds } = useMemo(()=>GetBulkBillingResultsDetailsTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsxs(Box, {
        className: styles.bulkBillingResultsDetails,
        children: [
            /*#__PURE__*/ _jsxs(Box, {
                className: styles.bulkBillingResultsDetailsLines,
                children: [
                    /*#__PURE__*/ _jsxs(Typography, {
                        className: classNames(styles.bulkBillingResultsDetailsLineItem, styles.bulkBillingResultsDetailsSuccess),
                        variant: "paragraph1",
                        testId: BulkBillingResultsDetailsTestIds.Success(),
                        skin: "success",
                        children: [
                            /*#__PURE__*/ _jsx(Checkmark, {
                                size: 16
                            }),
                            " ",
                            success,
                            " ",
                            pluralize('invoice', success),
                            " billed successfully"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Typography, {
                        className: classNames(styles.bulkBillingResultsDetailsLineItem, styles.bulkBillingResultsDetailsFailure),
                        variant: "paragraph1",
                        testId: BulkBillingResultsDetailsTestIds.Failure(),
                        skin: "error",
                        children: [
                            /*#__PURE__*/ _jsx(CloseCross, {}),
                            failure,
                            " ",
                            pluralize('invoice', failure),
                            " could not be billed due to an unknown error."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Typography, {
                skin: "secondary",
                children: [
                    "You can",
                    ' ',
                    /*#__PURE__*/ _jsx(ExternalLinkButton, {
                        testId: BulkBillingResultsDetailsTestIds.DownloadResults(),
                        href: "".concat(mgmtHost, "/billing/bulk/billing/").concat(bulkUploadId, "/failed-csv"),
                        target: "_blank",
                        bi: {
                            name: 'bulk_billing_download_failed_csv'
                        },
                        children: "download a csv"
                    }),
                    ' ',
                    "of the line ",
                    pluralize('item', failure),
                    " that could not be billed. For more details, please contact support."
                ]
            })
        ]
    });
};
